<ng-container *transloco="let t; prefix: 'admin'">
  <div appScrollTo class="container mat-elevation-z2 widget-background">
    <a routerLink="bookings/all">{{ t("page_bookings") }}</a>
  </div>
</ng-container>
